module.exports = __webpack_public_path__ + "img/hospitium-07.ebb85069.jpg";